import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
  filled?: boolean
}

const pathOutlined =
  'M8.437 13h9v4h7.437l-2.151-4.662a2 2 0 0 1 0-1.676L24.874 6h-5.437V1h-13v5H1l2.152 4.662a2 2' +
  ' 0 0 1 0 1.676L1 17h7.437v-4zm8 1h-7v3a1 1 0 0 1-1 1H1a1 1 0 0 1-.908-1.42l2.152-4.66a1 1 0 ' +
  '0 0 0-.84L.092 6.42A1 1 0 0 1 1 5h4.437V1a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v4h4.437a1 1 0 0 1 .' +
  '908 1.42l-2.151 4.66a1 1 0 0 0 0 .84l2.151 4.66a1 1 0 0 1-.908 1.42h-7.437a1 1 0 0 1-1-1v-3z' +
  'm-10-14h13a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 1v12h13V1h-13z'

const pathFilled =
  'M1.563 5.5a.5.5 0 0 0-.454.71L3.26 10.87a1.5 1.5 0 0 1 0 1.258L1.109 16.79a.5.5 0 0 0 .454.7' +
  '1H9a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H1.563zM25.437 17.5a.5.5 0 0 0 .454-.71L23.74 12.13a1' +
  '.5 1.5 0 0 1 0-1.258l2.152-4.661a.5.5 0 0 0-.454-.71H18a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h7.437z'

const RibbonIcon: React.SFC<Props> = ({ filled, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 27 18">
    {filled && (
      <>
        <defs>
          <rect id="RibbonIcon-Rect-Filled" x="6" width="15" height="14" rx="1" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#RibbonIcon-Rect-Filled" />
          <path d={pathFilled} stroke="currentColor" />
        </g>
      </>
    )}

    {!filled && (
      <path d={pathOutlined} fillRule="nonzero" fill="currentColor" />
    )}
  </SvgIcon>
)

export default RibbonIcon
